/**
 * Brand logo — matches the actual favicon PNG exactly:
 * Klein blue (#002FA7) square with a white right-angled triangle (set square).
 * Right angle is at the bottom-left; one leg goes up, one goes right.
 */
export default function Logo({ size = 32, className = "" }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      width={size}
      height={size}
      className={className}
      aria-label="Engineering Hub logo"
    >
      <rect width="32" height="32" fill="#002FA7" />
      {/* Right-angled triangle: right angle at bottom-left */}
      <polygon
        points="6,26 6,6 26,26"
        fill="white"
      />
    </svg>
  );
}
